import { AllPackingMehodsResponseModel, PackingMethodResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
// import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { PackingMethodCapacityRequest } from './dto/package-method-capacity.request';
import { PackingMethodRequest } from './dto/packing-mathods.request';
import {  PackingMethodsDTO } from './dto/packing-methods.dto';
import { UserRequestDto } from './dto/user-logs-dto';
import { PackingMathodsService } from './packing-mathods.service';
import { CommonResponse } from '@gtpl/shared-models/production-management';


@ApiTags('packing-methods')
@Controller('packing-mathods')
export class PackingMathodsController {
    constructor(
        private packingMethodService: PackingMathodsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      /**
     * creates or updates a value of Packing Methods
     * @param packingMethodDto packing Method DTO
     * @returns packing MethodResponse
     */
    @Post('/createPackingMethod')
    async createPackingMethod(@Body() packingMethodDto:PackingMethodsDTO,isUpdate:boolean=false,@Req() request:Request): Promise<PackingMethodResponseModel> {
        try {
         return await this.packingMethodService.createPackingMethod(packingMethodDto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(PackingMethodResponseModel, error);
       }
     }

      /**
     * gets all the Value of Packing Methods
     * @returns AllValue Packing MethodsResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

    @Post('/getAllPackingMethods')
    async getAllPackingMethods(@Body() req?:UserRequestDto): Promise<AllPackingMehodsResponseModel> {
        try {
            return await this.packingMethodService.getAllPackingMethods(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllPackingMehodsResponseModel, error);
        }
    }

    @Post('/getAllActivePackingMethods')
    async getAllActivePackingMethods(): Promise<AllPackingMehodsResponseModel> {
        try {
            return await this.packingMethodService.getAllActivePackingMethods();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllPackingMehodsResponseModel, error);
        }
    }

     /**
     * Activate Or De-Activate Value PackingMethod
     * @param getSinglePackingMethod PackingMethodResponseModel 
     * @returns Value PackingMethod
     */
   @Post('/activateOrDeactivatePackingMethod')
   async activateOrDeactivatePackingMethod(@Body() productReq: PackingMethodRequest): Promise<PackingMethodResponseModel> {
       try {
           return await this.packingMethodService.activateOrDeactivatePackingMethod(productReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(PackingMethodResponseModel, err);
       }
   }

    /**
     * creates or updates a value of PackingMethod
     * @param PackingMethodDto PackingMethod DTO
     * @returns PackingMethodResponse
     */
     @Post('/updatePackingMethod')
     async updatePackingMethod(@Body() packingMethodDto:PackingMethodsDTO,isUpdate:boolean=true,@Req() request:Request): Promise<PackingMethodResponseModel> {
         try {
          return await this.packingMethodService.createPackingMethod(packingMethodDto,true,request);
        } catch (error) {
             return this.applicationExceptionHandler.returnException(PackingMethodResponseModel, error);
        }
      }

      @Post('/getPalletCapacity')
   async getPalletCapacity(@Body() packingMethodCapacityRequest: PackingMethodCapacityRequest): Promise<PackingMethodResponseModel> {
       try {
           return await this.packingMethodService.getPalletCapacity(packingMethodCapacityRequest);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(PackingMethodResponseModel, err);
       }
   }
      @Post('/getPalletCapacityById')
   async getPalletCapacityById(@Body() packingMethodCapacityRequest: PackingMethodCapacityRequest): Promise<PackingMethodResponseModel> {
       try {
           return await this.packingMethodService.getPalletCapacityById(packingMethodCapacityRequest);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(PackingMethodResponseModel, err);
       }
   }
   @Post('/getPackingmethods')
   async getPackingmethods():Promise<CommonResponse>{
    try{
        return await this.packingMethodService.getPackingmethods()
    }catch(err){
        return this.applicationExceptionHandler.returnException(CommonResponse,err)
    }
   }
}
